export function formatStatus(takeMode, status) {
  let result = "";
  const self = takeMode === "SELF";
  if (status === "PAY" && self) {
    result = "待自取";
  } else if (status === "SHIPPING" && self) {
    result = "已发药";
  } else if (status === "COMPLETE" && self) {
    result = "已完成";
  } else if (status === "COMMENT") {
    result = "已完成";
  }
  return result;
}